import { Injectable } from '@angular/core';
import {DecodeSeoUriPipe} from '@signature-it/ngx-catalogue/pipes';
import {GenericConfig} from '@signature-it/ngx-generic/config';

declare let _: any;

@Injectable({
    providedIn: 'root'
})
export class UtilityService {

    protected breadcrumbs:Array<any> = [];
    protected list:Array<any> = [];
    protected toFind:string = "";
    protected deepResult: any;
    protected objectGroupResult: any;
    protected decodeSeoUri;
    protected groupTree;

    constructor(){
        this.decodeSeoUri = new DecodeSeoUriPipe();
    }

    public findObjectGroup(haystack) {
        this.traverseObjectGroup(haystack, this);
        return this.objectGroupResult;
    }

    public findDeep(haystack, needle, treeRootId?) {
        this.deepResult = {};
        this.traverse(haystack, needle, this, treeRootId);
        return this.deepResult;
    }

    public findDeepByAttr(haystack, needle, decodeSeo = false) {
        this.deepResult = null;
        this.traverseByAttr(haystack, _.toPairs(needle), this, decodeSeo);
        return this.deepResult;
    }

    public find(haystack, needle) {
        for (let key in haystack)
        {
            let item = haystack[key];
            if (item.id == needle)
                return item;
            if (item.children)
            {
                let subresult = this.find(item.children, needle);
                if (subresult)
                    return subresult;
            }
        }
        return null;
    }

    public getBreadcrumbs(groupTree, group, rootGroupSlug) {
        const toFind = group.id;
        this.groupTree = groupTree;
        const breadcrumbsCatalogHomeURL = GenericConfig.breadcrumbsCatalogHomeURL;
        let rootUrl = rootGroupSlug ? `/${group.catalogueFriendlyUrl}/${rootGroupSlug}` : `/${groupTree.catalogueUrl}/${groupTree[groupTree.idParam]}`;
        if(breadcrumbsCatalogHomeURL) {
            rootUrl = breadcrumbsCatalogHomeURL;
        }
        this.list = [];
        this.toFind = toFind;
        this.traverseBreadcrumbs(groupTree, [], this);
        if(this.list.length < 1) {
            this.list[0] = [];
            this.list[0].push({
                name: groupTree.name,
                groupId: groupTree[groupTree.idParam],
                url: rootUrl,
                isleaf: groupTree.isleaf,
                catalogueUrl: groupTree.catalogueUrl,
                idParam: groupTree.idParam,
                entityUri: groupTree.entityUri
            });
        } else {
            this.list[0].unshift({
                name: groupTree.name,
                groupId: groupTree[groupTree.idParam],
                url: rootUrl,
                isleaf: groupTree.isleaf,
                catalogueUrl: groupTree.catalogueUrl,
                idParam: groupTree.idParam,
                entityUri: groupTree.entityUri
            });
        }

        return this.list;
    }

    protected traverseBreadcrumbs(node, path, that) {
        if(!path)
            path = [];

        if(node.slug && node.id != this.groupTree.id && node.slug !== "Object" && node.slug !== "Catalogue" && !node.ignoreBreadcrumbs) {
            path.push(
                {
                    name:node.slug,
                    groupId:node[node.idParam],
                    isleaf: node.isleaf,
                    url: node.getUrl(),
                    catalogueUrl: node.catalogueUrl,
                    idParam: node.idParam,
                    entityUri: node.entityUri
                }
            );
        }
        if(node.children) {
            node.children.forEach(function(item) {
                if(item.id === that.toFind) {
                    if(item.slug === "Catalogue") {
                        item.id = "1";
                    }
                    path.push(
                        {
                            name:item.slug,
                            groupId:item[item.idParam],
                            isleaf: item.isleaf,
                            url: item.getUrl(),
                            catalogueUrl: item.catalogueUrl,
                            idParam: item.idParam,
                            entityUri: node.entityUri
                        }
                    );
                    that.list.push(path);
                }
                if(that.findDeep(item, {id: that.toFind})) {
                    that.traverseBreadcrumbs(item, path.slice(), that);
                }
            });
        }
    }

    protected traverse(value, attrs, that, treeRootId?) {
        let result;
        if (value) {
            if(value.isRoot) {
                if (that.match(value.id, attrs)) {
                    result = value;
                }
            }
            if(value.children)
            for(let val of value.children) {
                if (val.id) {
                    let checkedVal = false;
                    if(Array.isArray(attrs)) {
                        if (that.match(val.id, attrs)) {
                            checkedVal = true;
                        }
                    }
                    else if(attrs.hasOwnProperty('id')){
                        if(val.id === attrs.id) {
                            checkedVal = true;
                        }
                    }
                    else {
                        if(val.id === attrs) {
                            checkedVal = true;
                        }
                    }
                    if(checkedVal) {
                        result = val;
                        break;
                    }
                }
                if (_.isObject(val) || _.isArray(val)) {
                    that.traverse(val, attrs, that);
                }
            }
            if(result) {
                that.deepResult = result;
                return result;
            }
        }
    }

    protected traverseByAttr(value, attrs, that, decodeSeo = false) {
        if (that.deepResult) {
            return that.deepResult;
        }
        if (value) {
            let found = true;
            for (const attr of attrs) {
                const att_value = decodeSeo && _.isString(value[attr[0]]) ? this.decodeSeoUri.transform(value[attr[0]]) : value[attr[0]];
                if (att_value !== attr[1]) {
                    found = false;
                    break;
                }
            }
            if (found) {
                that.deepResult = value;
                return value;
            }
            if(value.children)
            for (const val of value.children) {
                that.traverseByAttr(val, attrs, that, decodeSeo);
            }
            return null;
        }
    }

    protected traverseObjectGroup(value, that) {
        let result;
        if (value) {
            for(let val of value.children) {
                if (val.slug && val.slug == "Object"){
                    result = val.id;
                    break;
                }
                if (_.isObject(val) || _.isArray(val)) {
                    that.traverseObjectGroup(val, that);
                }
            }
            if(result) {
                that.objectGroupResult = result;
                return result;
            }
        }
    }

    protected match(value, attrs) {
        for (let key in attrs) {
            if(!_.isUndefined(value)) {
                if (attrs[key] != value) {
                    return false;
                }
            }
        }
        return true;
    }

}
